/**
 * Default User Settings
 *
 * Single source of truth for the initial settings object
 * written to users/{uid}.settings on signup.
 * Feature-flag defaults are merged in from featureFlagDefinitions.
 */

import { defaultUserSettings } from './featureFlagDefinitions';

export const DEFAULT_USER_SETTINGS = {
  // Admin-configurable defaults (also in template)
  collapsedSections: false,
  transcriptTrayPosition: "right", // "right" | "bottom" — persisted from Transcript Tray
  clinicianDisplayName: "",        // User's preferred name for speaker role assignment (e.g., "Dr. Smith")

  // Runtime defaults — not in Admin Templates UI.
  transcriptType: "diarized",     // retain until its document formatter consumer is migrated
  documentType: 1,                // last selected document type in AppShell recording
  microphone: "default",          // user picks at runtime, never admin-set
  audioProvider: "deepgram",      // single provider, never changes

  // Feature flags (from template)
  ...defaultUserSettings,
};

export function buildNewUserSettings(presetSettings = {}) {
  const activeSettings = Object.fromEntries(
    Object.entries(presetSettings).filter(([key]) => Object.prototype.hasOwnProperty.call(DEFAULT_USER_SETTINGS, key)),
  );
  return { ...DEFAULT_USER_SETTINGS, ...activeSettings };
}
